/*********************** Custom JS for Boost AI Search & Discovery  ************************/

/* HC - Boost custom adjustments - 10 Jul '24 */
const customize = {
  updateProductItemGrid: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Add Extra Information',
      enabled: true,
      apply: () => ({
        afterRender(element){
          try{
            let productData = element.getParams().props.product;
            let productId = productData.id;
            if(productData?.split_product){
              productId = productData.variant_id;
            }            
            let productItem = document.querySelector('[data-product-id="'+productId+'"]');
            // hcHTML = '<div class="hc-glass-holder"><button onclick="fitmixInstance.setFrame(); fitmixInstance.startVto()" class="hc-glass-view hc-var-{{ variant.id }}"><span class="hc-fittingbox-image"></span></button></div>';
            if(productItem){
              let itemVirtualHtml = '';
              let firstVariant = productData.variants[0];
              itemVirtualHtml += '<div class="hc-colc-glass-holder">';              
              for (var i = 0; i < productData.variants.length; i++) {
                let variant = productData.variants[i];
                let foundVariantMeta = productData.metafields.filter(function(e) {
                  return e.id == variant.id && e.key == 'glass_id' && e.value;
                })
                if (typeof foundVariantMeta[0] !== 'undefined') {
                  let onClickFunc = "fitmixInstance.setFrame('" + foundVariantMeta[0]['value'] + "'); fitmixInstance.startVto('live');";
                  itemVirtualHtml += '<button onclick="' + onClickFunc + '" class="hc-colc-tryon hc-colc-var-' + foundVariantMeta[0]['id'] + 
                                      (firstVariant.id == foundVariantMeta[0]['id'] ? ' hc-colc-glass-active' : '') + '">';
                  itemVirtualHtml += '<span class="hc-fittingbox-image">Essayer</span>';
                  itemVirtualHtml += '</button>';
                }
              }
              itemVirtualHtml += '</div>';
              if (!productItem.querySelector('.hc-colc-glass-holder')) {
                productItem.querySelector('.boost-sd__product-item-grid-view-layout-image').insertAdjacentHTML('beforeend', itemVirtualHtml);
              }
              
            }
          } catch (e){
            console.warn(e);
          }
        }
      })
    });
  },
  removeOOSProductSwatches: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductSwatch', {
       name: 'Customize swatches',
       enabled: true,
       apply: () => ({
          props: (props) => {
             props.maxItem = 100; // Show all swatches by increasing number of swatches displayed to 100 (optional)
             return props;
          },
          afterRender(element) {
             const swatchOptions = element?.getParams()?.props?.options;
             const productData =
                componentRegistry.getNearestParentElm(element, 'ProductItemWidget')?.getParams()?.props?.product ||
                componentRegistry.getNearestParentElm(element, 'QuickView')?.getParams()?.props?.productData;
            let productId = productData.id;
            if (productData?.split_product) {
               productId = productData.variant_id;
            }
            let productItem = document.querySelector('[data-product-id="' + productId + '"]');
             if (swatchOptions?.length && productData) {
                const productVariants = productData.variants || [];
                swatchOptions.forEach((option, index) => {
                   const optionValue = option.value;
                   option.available = checkOptionStatus(productVariants, optionValue);
                   if (!option.available) {
                      const swatchOption = document.querySelector(`label[for*="${option.id}"]`);
                      if (swatchOption && swatchOption.closest('.boost-sd__product-swatch-option')) {
                         swatchOption.closest('.boost-sd__product-swatch-option').classList.add('sold-out');
                      }
                   }
                    if (index > 2) {
                      const swatchOption = document.querySelector(`label[for*="${option.id}"]`);
                      if (swatchOption && swatchOption.closest('.boost-sd__product-swatch-option')) {
                         swatchOption.closest('.boost-sd__product-swatch-option').classList.add('boost-sd-hidden');
                      }
                    }
                });
                if (swatchOptions.length > 3) {
                  let moreHtml = `<span class="product-block-options__more-label">+ ${swatchOptions.length - 3} de plus</span>`;
                  if (!productItem.querySelector('.product-block-options__more-label')) {
                     productItem.querySelector('.boost-sd__product-swatch-options').insertAdjacentHTML('afterend', moreHtml);
                  }
                }
             }
          },
       }),
    });
 },
}

function checkOptionStatus(variants, optionValue) {
   for (let i = 0; i < variants.length; i++) {
      const variant = variants[i];
      const variantOptions = variant.title?.split(' / ') || [];
      if (variantOptions.some((option) => option.toLowerCase() === optionValue.toLowerCase() && variant.available)) {
         return true;
      }
   }
   return false;
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.updateProductItemGrid,
  customize.removeOOSProductSwatches
]);